const ARGS_DELIMETER = "\t";
const LINE_DELIMETER = "\n";

const Type = {
	WINDOW_LOAD: "WINDOW_LOAD",
	WINDOW_UNLOAD: "WINDOW_UNLOAD",
	WINDOW_FOCUS: "WINDOW_FOCUS",
	WINDOW_RESIZE: "WINDOW_RESIZE",

	PAGE_ROUTE: "PAGE_ROUTE",
	SHOW_MODAL: "SHOW_MODAL",

	TASK_START: "TASK_START",
	TASK_COMPLETE: "TASK_COMPLETE",
	TASK_NEXT: "TASK_NEXT",

	CARD_DRAGSTART: "CARD_DRAGSTART",
	CARD_DRAG: "CARD_DRAG",
	CARD_DRAGEND: "CARD_DRAGEND",
	CARD_PLACE: "CARD_PLACE",
	CARD_EXPLORE: "CARD_EXPLORE",
	CARD_VERIFY: "CARD_VERIFY",

	SLOT_DRAGSTART: "SLOT_DRAGSTART",
	SLOT_DRAG: "SLOT_DRAG",
	SLOT_DRAGEND: "SLOT_DRAGEND",
	SLOT_SWAP: "SLOT_SWAP",
	SLOT_TOGGLE: "SLOT_TOGGLE",

	ARROW_DRAGSTART: "ARROW_DRAGSTART",
	ARROW_DRAG: "ARROW_DRAG",
	ARROW_DRAGEND: "ARROW_DRAGEND",
	ARROW_PLACE: "ARROW_PLACE",
	ARROW_REVEAL: "ARROW_REVEAL",
	ARROW_HINT: "ARROW_HINT",

	SLIDER_CHANGE: "SLIDER_CHANGE",
	INPUT_CHANGE: "INPUT_CHANGE",
	INPUT_VERIFY: "INPUT_VERIFY",

	QUESTION_START: "QUESTION_START",
	QUESTION_VERIFY: "QUESTION_VERIFY",
	QUESTION_COMPLETE: "QUESTION_COMPLETE",
	QUESTION_TRY_AGAIN: "QUESTION_TRY_AGAIN",
	QUESTION_NEXT: "QUESTION_NEXT",
	QUESTION_CHANGE_ANSWER: "QUESTION_CHANGE_ANSWER",

	// UPDATE_PERFORMANCE: "UPDATE_PERFORMANCE",

	LANGUAGE_CHANGE: "LANGUAGE_CHANGE",
	LOG_OUT: "LOG_OUT",

	// Clicking anywhere
};


export default class Logger {
	constructor() {
		this.logs = [];
		this.logsBuffer = [];
		this.logsLimit = 20;
		this.prevEvent = { x: 0, y: 0 };
		this.fetchError = null;
		this.timer = null;
		this.connectionEstablished = false;
		this.lockUpload = false;

		addEventListener("beforeunload", () => {
			this.onWindowUnload();
		});
	}

	initSession() {
		this.connectionEstablished = true;
	}

	init() {
		this.onWindowLoad();
	}

	upload() {
		if (this.logs.length == 0) { return; }
		if (!this.connectionEstablished) { return; }
		if (this.lockUpload) { return; }

		console.log("Uploading logs:", this.logs.length);
		this.logsBuffer = [...this.logs];
		this.logs = [];
		this.lockUpload = true;
		clearTimeout(this.timer);

		fetch("/api/update_logs/", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				logs: this.logsBuffer.join(LINE_DELIMETER) + LINE_DELIMETER
			})
		})
		.then(response => response.text())
		.then(message => {
			let data = null;
			this.lockUpload = false;
			try {
				data = JSON.parse(message);
				this.fetchError = data.error || null;
			}
			catch (error) {
				this.fetchError = message;
				this.onUploadError();
			}
			if (data) {
				try {
					if (data.success) {
						console.log("Upload successful!");
						this.logsLimit = 100;
					}
					else {
						this.onUploadError();
					}
				}
				catch (error) {
					this.fetchError = error;
					this.onUploadError();
				}
			}
		})
		.catch(error => {
			this.fetchError = error.toString();
			this.onUploadError();
		})
	}

	onUploadError() {
		console.error('Upload failed:', this.fetchError);
		this.logs = this.logsBuffer.concat(this.logs);
		this.logsBuffer = [];
		this.logsLimit = this.logs.length + 50;
	}

	add() {
		const unixTime = (new Date()).getTime();
		let args = Array.from(arguments);
		args.unshift(unixTime);

		// Convert arrays to strings correctly
		args = args.map(arg => {
			return (typeof arg === 'string') ? arg : JSON.stringify(arg);
		});

		args = args.join(ARGS_DELIMETER);
		this.logs.push(args);
		// console.log("LOGGER ADD:", args);

		clearTimeout(this.timer);
		this.timer = setTimeout(() => {
			this.upload();
		}, 10000);

		if (this.logs.length >= this.logsLimit) {
			this.upload();
		}
	}

	addMouse(type, cardId, eventX, eventY, canvasX, canvasY, priority) {
		if (eventX == 0 && eventY == 0) return;

		eventX = eventX ? eventX.toFixed() : 0;
		eventY = eventY ? eventY.toFixed() : 0;
		canvasX = canvasX ? canvasX.toFixed() : 0;
		canvasY = canvasY ? canvasY.toFixed() : 0;

		const dx = eventX - this.prevEvent.x;
		const dy = eventY - this.prevEvent.y;
		const dist = Math.sqrt(dx*dx + dy*dy);
		const minDist = 30;

		if (dist > minDist || priority) {
			this.prevEvent.x = eventX;
			this.prevEvent.y = eventY;
			this.add( type, cardId, eventX, eventY, canvasX, canvasY );
		}
	}


	/* Events */

	// On webpage load or refresh
	onWindowLoad() {
		this.add( Type.WINDOW_LOAD );
	}
	// On webpage unload or refresh
	onWindowUnload() {
		this.add( Type.WINDOW_UNLOAD );
		this.upload();
	}
	// On webpage focus change
	onWindowFocus(isFocused) {
		this.add( Type.WINDOW_FOCUS, isFocused );
	}
	// On webpage resize
	onWindowResize(clientWidth, clientHeight, canvasSize) {
		// console.log(clientWidth, clientHeight, canvasSize);
		this.add( Type.WINDOW_RESIZE, clientWidth, clientHeight, canvasSize );
	}

	// On navigating to a new part on the webpage
	onPageRoute(routeName, routePath) {
		this.add( Type.PAGE_ROUTE, routeName, routePath );
	}
	// On toggling a modal pop-up
	onShowModal(modalName, isOpened) {
		this.add( Type.SHOW_MODAL, modalName, isOpened );
	}

	// On task or quiz start
	onTaskStart(taskId, taskType, cardType, difficulty) {
		this.add( Type.TASK_START, taskId, taskType, cardType, difficulty );
	}
	// On task or quiz completed
	onTaskComplete(taskId) {
		this.add( Type.TASK_COMPLETE, taskId );
		this.upload();
	}
	// On user pressing "continue"
	onTaskNext(taskId) {
		this.add( Type.TASK_NEXT, taskId );
	}

	// On start of dragging card
	onCardDragStart(cardId, eventX, eventY, canvasX, canvasY) {
		this.addMouse( Type.CARD_DRAGSTART, cardId, eventX, eventY, canvasX, canvasY, true );
	}
	// On mouse movement during drag
	onCardDrag(cardId, eventX, eventY, canvasX, canvasY) {
		this.addMouse( Type.CARD_DRAG, cardId, eventX, eventY, canvasX, canvasY, false );
	}
	// On drag interrupt
	onCardDragEnd(cardId, eventX, eventY, canvasX, canvasY) {
		this.addMouse( Type.CARD_DRAGEND, cardId, eventX, eventY, canvasX, canvasY, true );
	}
	// On placing card on a slot
	onCardPlace(cardId, slotId, occupantId, accepted) {
		this.add( Type.CARD_PLACE, cardId, slotId, occupantId, accepted );
	}
	// On exploring a card
	onCardExplore(cardValue, firstTime) {
		this.add( Type.CARD_EXPLORE, cardValue, firstTime );
	}
	// On user pressing "verify" or "check your answer" in a cards task
	onCardVerify(slotIdList, cardIdList, correctPairs, allCorrect) {
		this.add( Type.CARD_VERIFY, slotIdList, cardIdList, correctPairs, allCorrect );
		this.upload();
	}

	// On start of dragging slot, for swapping or removing cards
	onSlotDragStart(slotId, eventX, eventY, canvasX, canvasY) {
		this.addMouse( Type.SLOT_DRAGSTART, slotId, eventX, eventY, canvasX, canvasY, true );
	}
	// On mouse movement during drag
	onSlotDrag(slotId, eventX, eventY, canvasX, canvasY) {
		// this.addMouse( Type.SLOT_DRAG, slotId, eventX, eventY, canvasX, canvasY, false );
	}
	// On drag interrupt, removing card
	onSlotDragEnd(slotId, eventX, eventY, canvasX, canvasY) {
		this.addMouse( Type.SLOT_DRAGEND, slotId, eventX, eventY, canvasX, canvasY, true );
	}
	// On card being dragged between two slots
	onSlotSwap(slotId1, slotId2, cardValue1, cardValue2) {
		this.add( Type.SLOT_SWAP, slotId1, slotId2, cardValue1, cardValue2 );
	}
	// On clicking a slot with toggleable number info (m3t4)
	onSlotToggle(slotId, isShown) {
		this.add( Type.SLOT_TOGGLE, slotId, isShown );
	}

	// On start of dragging arrow
	onArrowDragStart(slotId, eventX, eventY, canvasX, canvasY) {
		this.addMouse( Type.ARROW_DRAGSTART, slotId, eventX, eventY, canvasX, canvasY, true );
	}
	// On mouse movement during arrow drag
	onArrowDrag(slotId, eventX, eventY, canvasX, canvasY) {
		this.addMouse( Type.ARROW_DRAG, slotId, eventX, eventY, canvasX, canvasY, false );
	}
	// On arrow drag interrupt
	onArrowDragEnd(slotId, eventX, eventY, canvasX, canvasY) {
		this.addMouse( Type.ARROW_DRAGEND, slotId, eventX, eventY, canvasX, canvasY, true );
	}
	// On drawing an arrow between two slots
	onArrowPlace(slotId1, slotId2, success) {
		this.add( Type.ARROW_PLACE, slotId1, slotId2, success );
	}
	// On an arrow being revealed either through hints or through placing
	onArrowReveal(arrowId, cardValue) {
		this.add( Type.ARROW_REVEAL, arrowId, cardValue );
	}
	// On drawing an arrow between two slots
	onArrowHint(cardValue) {
		this.add( Type.ARROW_HINT, cardValue );
	}

	// On dragging a slider
	onSliderChange(sliderId, selectedIndex, selectedValue) {
		this.add( Type.SLIDER_CHANGE, sliderId, selectedIndex, selectedValue );
	}
	// On changing a value in an input task
	onInputChange(answers) {
		this.add( Type.INPUT_CHANGE, answers );
	}
	// On verifying input answers in a task
	onInputVerify(answers, correctAnswers, allCorrect) {
		this.add( Type.INPUT_VERIFY, answers, correctAnswers, allCorrect );
		this.upload();
	}

	// On question start
	onQuestionStart(id, mechanic, index, availableAnswers, correctAnswers) {
		this.add( Type.QUESTION_START, id, mechanic, index, availableAnswers, correctAnswers );
	}
	// On changing the answer
	onQuestionChangeAnswer(id, userAnswer) {
		this.add( Type.QUESTION_CHANGE_ANSWER, id, userAnswer );
	}
	// On submitting an answer
	onQuestionVerify(id, userAnswer, success) {
		this.add( Type.QUESTION_VERIFY, id, userAnswer, success );
		this.upload();
	}
	// On clicking try again
	onQuestionTryAgain(id) {
		this.add( Type.QUESTION_TRY_AGAIN, id );
	}
	// On getting the answer correctly
	onQuestionComplete(id) {
		this.add( Type.QUESTION_COMPLETE, id );
		this.upload();
	}
	// On clicking next question
	onQuestionNext(id) {
		this.add( Type.QUESTION_NEXT, id );
	}

	// On changing performance score
	// onUpdatePerformance(score, diff) {
	// 	this.add( Type.UPDATE_PERFORMANCE, score, diff );
	// }


	// On clicking next question
	onLanguageChange(locale, manually) {
		this.add( Type.LANGUAGE_CHANGE, locale, manually );
	}

	// On clicking log out
	onLogOut() {
		this.add( Type.LOG_OUT );
		this.upload();
	}
}
